import React, { ChangeEvent, FC, useState } from 'react';
import { FormControl, Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import { SearchContentInput, SubmitterRole } from 'api';

interface Props {
  filter: SearchContentInput;
  setFilter: (filter: SearchContentInput) => void;
}

enum Roles {
  All = 'all',
  External = 'external',
  User = 'user',
  Contributor = 'contributor',
  Moderator = 'moderator',
  Admin = 'admin',
}

const useStyles = makeStyles(() => ({
  dropdown: {
    minWidth: 140,
  },
}));

const Submitter: FC<Props> = ({ filter, setFilter }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const initialValue = !filter.submitter_role ? Roles.All : filter.submitter_role;
  const [selectValue, setSelectValue] = useState(initialValue || 'all');

  function onChange(event: ChangeEvent<HTMLSelectElement>) {
    const { value } = event.target;
    setSelectValue(value);

    switch (value) {
      case Roles.All:
        delete filter.submitter_role;
        break;
      case Roles.External:
        setFilter({ ...filter, submitter_role: SubmitterRole.External });
        break;
      case Roles.User:
        setFilter({ ...filter, submitter_role: SubmitterRole.User });
        break;
      case Roles.Contributor:
        setFilter({ ...filter, submitter_role: SubmitterRole.Contributor });
        break;
      case Roles.Moderator:
        setFilter({ ...filter, submitter_role: SubmitterRole.Moderator });
        break;
      case Roles.Admin:
        setFilter({ ...filter, submitter_role: SubmitterRole.Admin });
        break;
    }
  }

  return (
    <Grid item container alignItems="center">
      <Grid item xs={3}>
        <Typography variant="body2">{t('admin:submitterRole')}</Typography>
      </Grid>
      <Grid item xs={8} container justify="flex-start">
        <FormControl>
          <Select
            className={classes.dropdown}
            value={selectValue}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onChange={onChange}
          >
            <MenuItem value={Roles.All}>{t('common:all')}</MenuItem>
            <MenuItem value={Roles.External}>{t('common:external')}</MenuItem>
            <MenuItem value={Roles.User}>{t('common:user')}</MenuItem>
            <MenuItem value={Roles.Contributor}>{t('common:contributor')}</MenuItem>
            <MenuItem value={Roles.Moderator}>{t('common:moderator')}</MenuItem>
            <MenuItem value={Roles.Admin}>{t('common:admin')}</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default Submitter;
